var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ve-line',{attrs:{"grid":_vm.grid,"settings":_vm.settings,"data":_vm.data,"colors":_vm.color,"xAxis":_vm.xAxis,"yAxis":_vm.yAxis,"resizeable":""}})}
var staticRenderFns = []

export { render, staticRenderFns }